import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";
import { useGlobalContext } from "../../../Context/GlobalContext";
import PayrollIncentive from "../../../components/Staff/Modals/PayrollIncentiveModel";
import PayrollAddIncentive from "../../../components/Staff/Modals/PayrollAddIncentive";
import PayrollFinalizedSidebar from "../../../components/Staff/Modals/PayrollFinalizedSidebar";
import { saveAs } from "file-saver";
import { usePayrollContext } from "../../../Context/PayrollContext";

const PayrollIncentives = () => {
  const {
    isLoading,
    openToast,
    baseUrl,
    staffs,
    fetchStaffs,
    setSelectedStaff,
    branchData,
    departments,
    handleChangeBranch,
    handleChangeDepartment,
    selectBranch,
    selectDepartments,
    resetState,
  } = useGlobalContext();

  let subtitle;
  const { fetchPayrollDetails, handleMonthChange, year, month, payrollDetail, loading } = usePayrollContext();
  const [toggleDrop11, setToggleDrop11] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isOffCanvasOpenAction, setIsOffCanvasOpenAction] = useState(false);
  const [name, setName] = useState("");
  const [paidPaymentPrice, setPaidPaymentPrice] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [payrollFinalized, setPayrollFinalized] = useState(false);
  const [selectedPayroll, setSelectedPayroll] = useState(null);

  const toggleOffCanvasAction = () => {
    setIsOffCanvasOpenAction(!isOffCanvasOpenAction);
  };

  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  function handledrop11() {
    setToggleDrop11(!toggleDrop11);
  }

  useEffect(() => {
    fetchStaffs();
  }, []);

  const [modalIsOpen9, setIsOpen9] = React.useState(false);
  function openModal9() {
    setIsOpen9(true);
  }
  function afterOpenModal9() {
    subtitle.style.color = "#000";
  }

  function closeModal9() {
    setIsOpen9(false);
  }
  // when onclick update staff

  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDrop = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setActiveDropdown(null);
    }
  };
  const toggleOffCanvas = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };
  const [types, setTypes] = useState([]);

  const toggleOffCanvasPayrollFinalized = () => {
    setPayrollFinalized(!payrollFinalized);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  async function fetchTypes() {
    try {
      const result = await fetch(baseUrl + "incentives/type/", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        const data = await result.json();
        console.log(data);

        setTypes(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    fetchTypes();
  }, []);




  const exportToCSV = () => {
    // Prepare the CSV headers
    const headers = [
      "Index",
      "Name",
      "Job Title",
      "Ctc",
      "Payroll Finalized",
      "Total Incentives",
    ];

    // Map over the data to create CSV rows
    const rows = payrollDetail.map((staff, index) => [
      index + 1,
      staff?.name || "N/A",
      staff?.staffDetails?.job_title || "N/A",
      staff?.staffDetails?.SalaryDetails[0]?.ctc_amount || "N/A",
      staff?.staffDetails?.SalaryDetails[0]?.payroll_finalized ? "Yes" : "No",
      staff?.staffDetails?.SalaryDetails[0]?.Incentive.reduce(
        (t, c) => t + c.amount,
        0
      ) ?? "0.00",
    ]);

    // Combine headers and rows for CSV format
    const csvData = [headers, ...rows].map((row) => row.join(",")).join("\n");

    // Create a Blob and download the file
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "PayrollIncentives.csv");
  };

  return (
    <>
      <PayrollIncentive
        offCanvas={toggleOffCanvas}
        isOffCanvasOpen={isOffCanvasOpen}
        setIsOffCanvasOpen={toggleOffCanvas}
        pesonalDetail={name}
        paidPayment={paidPaymentPrice}
        setPaidPayment={setPaidPaymentPrice}
        item={selectedItem}
        fetchPayrollFn={fetchPayrollDetails}
      />
      <PayrollAddIncentive
        types={types}
        isOffCanvasOpenAction={isOffCanvasOpenAction}
        setIsOffCanvasOpenAction={toggleOffCanvasAction}
        toggleOffCanvasAction={toggleOffCanvasAction}
        item={name}
        fetchPayrollFn={fetchPayrollDetails}
        fetchTypes={fetchTypes}
      />
      <PayrollFinalizedSidebar
        offCanvas={toggleOffCanvasPayrollFinalized}
        isOffCanvasOpen={payrollFinalized}
        setIsOffCanvasOpen={toggleOffCanvasPayrollFinalized}
        data={selectedPayroll}
        fetchPayrollDetails={fetchPayrollDetails}
      />

      <div className="mt-[20px]">
        <div className="flex lg:flex-row xl:flex-row flex-col md:flex-col justify-between items-end gap-[15px] lg:gap-[0px]">
          <div className="flex lg:flex lg:flex-row flex-col gap-[10px] lg:gap-[20px] w-full">
            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Payroll Month
              </label>
              <br />
              <input
                type="month"
                onChange={handleMonthChange}
                className="p-[8px] border rounded-md w-[100%] lg:w-[240px] text-sm focus-visible:outline-none"
                value={`${year}-${month}`}
              />
            </div>
            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Company Branches
              </label>
              <br />
              <select
                value={selectBranch}
                onChange={(e) => handleChangeBranch(e.target.value)}
                className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none"
              >
                <option value="">Select a Branch</option>
                {branchData.map((branch, index) => (
                  <option key={index} value={branch?.branchName}>
                    {branch?.branchName}
                  </option>
                ))}
              </select>
            </div>

            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Departments
              </label>
              <br />
              <select
                value={selectDepartments}
                onChange={(e) => handleChangeDepartment(e.target.value)}
                className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none"
              >
                <option>Select a Department</option>
                {departments.map((departmentName, index) => (
                  <option key={index} value={departmentName?.department_name}>
                    {departmentName?.department_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="xl:w-[240px] set-incentive-div">
              <label htmlFor="" className="hidden font-medium text-[14px]">
                Departments
              </label>
              <br />
              {/* <div className='w-full md:w-auto'> */}
              {/* <button onClick={openModal9} className='justify-center w-full md:w-auto second-btn'>Import Incentives</button> */}
              <button onClick={resetState} className="second-btn">
                Reset
              </button>
              {/* </div> */}
            </div>
          </div>
          {/* {toggleDrop11 && (
            <div className="">
              <Link to="#" className="second-btn">
                Reset
              </Link>
            </div>
          )} */}
        </div>

        <div className="mt-[20px]">
          <div className="flex lg:flex-row xl:flex-row flex-col justify-between items-start lg:items-center xl:items-center gap-[10px] mb-[20px]">
            <div className="relative summary-border rounded-[10px] w-full lg:w-[240px] xl:w-[240px]">
              <input
                type="text"
                placeholder="Search"
                className="px-[10px] py-[9px] pr-[26px] pl-[10px] rounded-[10px] text-[13px] client-add focus-visible:outline-none"
              />
              <SearchIcon className="top-[12px] right-[6px] absolute text-gray-500 newadd2" />
            </div>

            <button
              onClick={openModal9}
              className="justify-center w-full md:w-auto second-btn"
            >
              Import Incentives
            </button>
          </div>
        </div>

        <div className="text-end"></div>
        <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full h-[100%] overflow-x-auto">
          <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
            {/* Header with Toggle */}
            <thead
              className="border-gray-300 shadow-md border cursor-pointer"
              onClick={toggleAccordion}
            >
              <tr>
                {/* <th className="flex justify-center p-[10px] border-r h-[40px] font-medium text-center text-xs whitespace-nowrap">
                  <input type="checkbox" />
                </th> */}

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Name
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("name")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "name" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Job Title
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("job")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "job" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    CTC
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("ctc")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "ctc" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Payroll Finalized
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Total Incentives
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("total")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "total" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">Action</div>
                </th>
              </tr>
            </thead>

            <tbody className="w-full">
              {loading && (
                <tr className="h-[100px]">
                  <td
                    colSpan="9"
                    className="border-[#dbdbdb] py-4 font-semibold text-center text-gray-600 text-xl whitespace-nowrap"
                  >
                    <ClipLoader color="#24007a" size={50} />
                  </td>
                </tr>
              )}
              {!loading &&
                payrollDetail &&
                payrollDetail?.map((staff) => {
                  console.log(staff);
                  let formattedPending = 0;
                  let formattedTotal = 0;
                  return (
                    <tr className="border">
                      {/* <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                        <input
                          type="checkbox"
                          className="border-1 border rounded-md"
                        />
                      </td> */}
                      <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                        <Link
                          onClick={() => setSelectedStaff(staff)}
                          to={`/personal-detail/${staff?.id}`}
                          className="font-medium text-[#8A25B0] cursor-pointer"
                        >
                          {staff?.name || "N/A"}
                        </Link>
                      </td>
                      <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                        {staff?.staffDetails?.job_title || "N/A"}
                      </td>

                      {staff?.staffDetails?.SalaryDetails[0]?.ctc_amount ? (
                        <>
                          {/* Show all columns if ctc_amount is available */}
                          <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                            ₹{" "}
                            {staff?.staffDetails?.SalaryDetails[0]
                              ?.ctc_amount || "N/A"}
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#24007a] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setSelectedPayroll({
                                  ...staff,
                                  pending: formattedPending,
                                  total: formattedTotal,
                                });
                                setPayrollFinalized(true);
                              }}
                            >
                              {staff?.staffDetails?.SalaryDetails[0]
                                ?.payroll_finalized
                                ? "Yes"
                                : "No"}
                            </button>
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#24007a] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setIsOffCanvasOpen(true);
                                setName(staff);
                                setSelectedItem(staff);
                              }}
                            >
                              ₹{" "}
                              {staff?.staffDetails?.SalaryDetails[0]?.Incentive.reduce(
                                (t, c) => t + c.amount,
                                0
                              ) ?? "0.00"}
                            </button>
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#24007a] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setIsOffCanvasOpenAction(true);
                                setName(staff);
                              }}
                            >
                              Add Incentive
                            </button>
                          </td>
                        </>
                      ) : (
                        // Show a single column if ctc_amount is not available
                        <td
                          className="border-[#dbdbdb] p-[10px] text-center text-xs whitespace-nowrap"
                          colSpan="4" // Span across all columns
                        >
                          Please{" "}
                          <Link
                            to={`/salary-details-edit/${staff?.id}`}
                            onClick={() => {
                              setSelectedStaff(staff);
                            }}
                            className="font-medium text-[#24007a]"
                          >
                            add ctc
                          </Link>{" "}
                          to see incentives
                        </td>
                      )}
                    </tr>
                  );
                })}

              {
                !loading && payrollDetail?.length == 0 && (
                  <tr className="h-[100px]">
                    <td
                      colSpan="9"
                      className="border-[#dbdbdb] py-4 text-[14px] text-black text-center whitespace-nowrap"
                    >
                      No Data Found
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
        <div className="w-full">
          <h2 className="p-[10px] pl-2 whitespace-nowrap">Grand Total</h2>
        </div>

        {/* when onclick update staff */}

        <Modal
          isOpen={modalIsOpen9}
          onAfterOpen={afterOpenModal9}
          onRequestClose={closeModal9}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg font-medium text-[14px] text-center"
          >
            Import Incentives for all Staff
          </h2>
          <button
            onClick={closeModal9}
            className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="pb-2">
            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 font-medium text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[0px]">
                <h4 className="m-0 font-medium">
                  Step 1. Download Salarybox Incentive Template.
                </h4>
              </div>
              <div className="flex items-center">
                <Link
                  to="#"
                  className="p-1 rounded-md text-[13px] whitespace-nowrap outline-1 outline-dashed outline-offset-1"
                  onClick={exportToCSV}
                >
                  Download Template
                </Link>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 font-medium text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[0px]">
                <h4 className="m-0 font-medium">Step 3. Upload Incentives</h4>
              </div>
              <div className="flex items-center">
                <button className="p-1 rounded-md text-[13px] outline-1 outline-dashed outline-offset-1">
                  Import Incentives
                </button>
                {/* <input type='file' placeholder='ddjfksj'/> */}
              </div>
            </div>
          </div>
        </Modal>
        {/* when onclick update staff
         */}
      </div>
    </>
  );
};

export default PayrollIncentives;
